import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { configSalesmanProspectMonitoringTeam } from "../config";
import { mapToDDL } from "../../../../../common/mapper";

export default class SalesmanProspectReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableConfig: configSalesmanProspectMonitoringTeam,
    };
  }

  render() {
    return (
      <div style={{ padding: 10 }}>
        <FlexView style={{ alignItems: "center", marginBottom: "10px" }}>
          <SimpleDDL
            id="select_options_tl_name"
            box="search"
            isClearable
            containerclassname="width width-200px"
            placeholder="Nama TL"
            options={this.props.listTeamLead.map((x) =>
              mapToDDL(x.salesLeadName, x.employeeId)
            )}
            value={this.props.selectedTL}
            onChange={(value) => {
              this.props.onSelectTL(value);
            }}
          />
          <SimpleButton
            onClick={() => {
              this.props.onSearch();
            }}
            styles={{ marginBottom: "15px" }}
          >
            CARI
          </SimpleButton>
        </FlexView>
        <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
          LAPORAN STATISTIK PROSPEK PER SALESMAN / CS
        </p>
        <SimpleDataTable
          data={this.props.dataTable}
          columns={configSalesmanProspectMonitoringTeam}
        />
      </div>
    );
  }
}
